import angular from "angular";

angular
    .module('ui-sentinel.shipments.templatesAdmin')
    .directive('templateGeofencePicker', TemplateGeofencePickerDirective);

// picks a geofence for one of a template's tracking strategy fields (an editor field holding
// value / isPristine / errors); shows the selection with a change button, or a filtered list to pick from
function TemplateGeofencePickerDirective() {
    return {
        restrict: 'A',
        scope: {
            field: '=',
            geofences: '=',
            editable: '=',
            listLimit: '=',
            onSelect: '&',
            onClear: '&'
        },
        controller: ThisDirectiveController,
        controllerAs: 'picker',
        bindToController: true,
        template: require('./template-geofence-picker-directive.html')
    };
}

function ThisDirectiveController() {
    const vm = this;
    vm.searchText = null;
    vm.filter = filter;
    vm.label = label;
    vm.select = select;
    vm.clear = clear;

    function filter(geofence) {
        if (!vm.searchText) {
            return true;
        }
        return geofence.name.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
    }

    function label(geofence) {
        if (!geofence) {
            return '';
        }
        return geofence.name + ", " + geofence.address + " (" + geofence.type + ")";
    }

    function select(geofence) {
        vm.onSelect({ geofence: geofence });
    }

    function clear() {
        vm.searchText = null;
        vm.onClear();
    }
}
